<div class="sticky sticky-crm pl-0 overflow-x-auto si-table-container" [formGroup]="form">
    <table class="si-table" [formArrayName]="mappingType">
        <thead>
            <tr>
                <th width="30%" scope="col" class="border-t-0 uppercase text-primary">SalesIntel FIELD</th>
                <th width="40%" scope="col" class="border-t-0 uppercase text-primary">{{exportType}} FIELD</th>
                <th width="30%" *ngIf="!useFullName" scope="col" class="text-center border-t-0 uppercase text-primary">Allow Overwrite
                </th>
            </tr>
        </thead>

        <tbody *ngIf="mappings?.length">
            <ng-container
                *ngFor="let salesIntelField of form.get(mappingType).controls; let first = first; let i = index;"
                [formGroupName]="i">
                <tr class="menu-item line-li"
                    *ngIf="!first && mappings[i-1] && mappings[i-1]?.groupId !== mappings[i]?.groupId">
                    <td colspan="3" class="group-mapping">&nbsp;</td>
                </tr>
                <tr>
                    <td class="capitalize align-middle" scope="row">
                        {{ mappings[i]?.salesintelField | salesintelPrettyField }}</td>
                    <td *ngIf="useFullName" class="capitalize align-middle" scope="row">
                        {{ mappings[i]?.outreachField}}</td>
                    <td *ngIf="!useFullName">
                        <ng-container *ngIf="mappings[i]?.isCustomizable">
                            <mat-form-field
                                *ngIf="leadSource.length > 0 && mappings[i]?.salesintelField === 'leadSource'; else commonList"
                                [class.mat-form-field-invalid]="(salesIntelField.value.isError || salesIntelField.hasError(duplicateFieldError))"
                                appearance="outline"
                                class="mb-2 w-full"
                            >
                                <mat-label>{{ mappings[i]?.salesintelField | salesintelPrettyField }}</mat-label>
                                <mat-select [formControlName]="exportControlName" (selectionChange)="isValid(salesIntelField.value.salesintelField)" #siSelectRef="matSelect">
                                    <mat-option [value]="null ? '' : ''">-- skip --</mat-option>
                                    <mat-option [value]="field.value" *ngFor="let field of leadSource[0].pickList">
                                        {{ field.label }}
                                    </mat-option>
                                </mat-select>
                                <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                            </mat-form-field>

                            <ng-template #commonList>
                                <mat-form-field [class.mat-form-field-invalid]="(salesIntelField.value.isError || salesIntelField.value.isBug || salesIntelField.hasError(duplicateFieldError))" appearance="outline" class="mb-2 w-full no-padding">
                                    <mat-label>{{ mappings[i]?.salesintelField | salesintelPrettyField }}</mat-label>
                                    <mat-select [formControlName]="exportControlName" (selectionChange)="isValid(salesIntelField.value.salesintelField)" #siSelectRef2="matSelect">
                                        <mat-option [value]="mappings[i]?.[exportControlName]"
                                                   *ngIf="salesIntelField.value.isBug"></mat-option>
                                        <mat-option [value]="''">-- skip --</mat-option>
                                        <mat-option [value]="field.field" *ngFor="let field of fieldArray | filterlist: mappings[i]?.type ">
                                            {{ field.label }}
                                        </mat-option>
                                    </mat-select>
                                    <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                                </mat-form-field>
                            </ng-template>
                        </ng-container>
                        <ng-container *ngIf="!mappings[i]?.isCustomizable">
                            <div class="p-2">{{ mappings[i]?.label }}</div>
                        </ng-container>
                    </td>
                    <td *ngIf="!useFullName" class="text-center align-middle">
                        <mat-slide-toggle formControlName="allowOverwrite" (change)="allowOverwriteChanged($event, salesIntelField.value.salesintelField)"></mat-slide-toggle>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
